import React from 'react';
import styled from 'styled-components';

function Links({ destinationName, travelInfoUrls }) {
  return (
    <Root>
      <DestinationName>{destinationName}:</DestinationName>
      <Content>
        {travelInfoUrls.map(({ title, url }, index) => (
          <span key={title}>
            {index ? ', ' : ''}
            <a href={url} target='_blank' rel='noopener noreferrer'>
              {title}
            </a>
          </span>
        ))}
      </Content>
    </Root>
  );
}

export default Links;

const Root = styled.div`
  display: flex;
  align-items: baseline;
`;

const DestinationName = styled.strong`
  margin-right: 8px;
`;

const Content = styled.div`
  font-size: 1em;
`;
